
// export default OverallScores;
// import React, { useState, useEffect, useRef } from 'react';
// import { computeOverallScore } from '../../utils/scoreUtils';
// import { cacheRead, cacheWrite, CacheKeys } from '../../utils/cacheKeys';
// import{AIInsightsPage} from '../../utils/AIInsightsPage'

// const GEMINI_API_KEY = "AIzaSyAk-HxQZ9PdZshANAhdEl7M4uTD3YxBtFI" || '';

// const cleanDomain = (url) =>
//   (url || '').replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// const getAuthorityData  = (domain)           => cacheRead(CacheKeys.authority(domain));
// const getPageSpeedData  = (domain)           => cacheRead(CacheKeys.pageSpeed(domain));
// const getGmbData        = (domain, location) => cacheRead(CacheKeys.gmb(domain, location));
// const getTechnicalData  = (domain)           => cacheRead(CacheKeys.technical(domain));

// const debugCacheDump = (domain, location) => {
//   console.group(`📦 Cache dump for: ${domain}`);
//   console.log('authority  →', getAuthorityData(domain));
//   console.log('pageSpeed  →', getPageSpeedData(domain));
//   console.log('gmb        →', getGmbData(domain, location));
//   console.log('technical  →', getTechnicalData(domain));
//   const matching = Object.keys(localStorage).filter(k => k.includes(domain));
//   console.log('All matching localStorage keys:', matching);
//   console.groupEnd();
// };

// const buildScoreInputs = (domain, location, gmbOverride = null) => {
//   const authority = getAuthorityData(domain)   || {};
//   const pageSpeed = getPageSpeedData(domain)   || {};
//   const gmb       = gmbOverride || getGmbData(domain, location) || {};
//   const tech      = getTechnicalData(domain)   || {};

//   const normPS = (val) => {
//     if (val == null) return 0;
//     return val <= 1 ? Math.round(val * 100) : val;
//   };

//   return {
//     domainAuthority:    authority.domain_authority   ?? 0,
//     spamScore:          authority.spam_score         ?? null,
//     domainAgeYears:     authority.domain_age_years   ?? 0,
//     referringDomains:   authority.referring_domains  ?? 0,
//     pageSpeedMobile:    normPS(pageSpeed?.mobile?.performance_score),
//     pageSpeedDesktop:   normPS(pageSpeed?.desktop?.performance_score),
//     isResponsive:       pageSpeed?.mobile?.viewport_meta_tag_present ?? null,
//     gmbRating:          gmb?.reviews?.rating          ?? 0,
//     reviewCount:        gmb?.reviews?.count           ?? 0,
//     daysSinceLastReview: gmb?.daysSinceLastReview     ?? null,
//     servicesCount:      gmb?.services_listed?.status === 'pass'
//                           ? (gmb?.services_listed?.value || 1)
//                           : (gmb?.services_listed?.value || 0),
//     hasSitemap:         tech?.sitemap?.status   === 'Present' ? true  : tech?.sitemap?.status   === 'Missing' ? false : null,
//     hasRobots:          tech?.robots_txt?.status === 'Present' ? true  : tech?.robots_txt?.status === 'Missing' ? false : null,
//     hasBrokenLinks:     (tech?.broken_links ?? null) === null ? null : (tech.broken_links > 0),
//     hasSSL:             tech?.ssl_status?.status === 'Secure' ? true  : tech?.ssl_status?.status === 'Insecure' ? false : null,
//   };
// };

// const getScoreLabel = (score) => {
//   if (score >= 80) return { label: 'Excellent',  cls: 'lbl-excellent', color: '#0D9488' };
//   if (score >= 65) return { label: 'Strong',     cls: 'lbl-strong',    color: '#1A73E8' };
//   if (score >= 45) return { label: 'Developing', cls: 'lbl-developing',color: '#C47D1A' };
//   return               { label: 'Needs Work',   cls: 'lbl-weak',      color: '#C0392B' };
// };

// const getOneliner = (name, score) => {
//   if (score >= 80) return `${name} has a strong, well-established presence that stands out in the market.`;
//   if (score >= 65) return `${name} is performing well with good visibility — a few key improvements could make it exceptional.`;
//   if (score >= 45) return `${name} has a growing presence but faces gaps that competitors are likely exploiting.`;
//   return `${name} has significant opportunities to improve its brand presence and visibility.`;
// };

// const getVsBadge = (clientScore, compScore) => {
//   const diff = clientScore - compScore;
//   if (diff > 3)  return `<span class="vs-badge vs-ahead">▲ ${diff} pts ahead</span>`;
//   if (diff < -3) return `<span class="vs-badge vs-behind">▼ ${Math.abs(diff)} pts behind</span>`;
//   return `<span class="vs-badge vs-tied">≈ Tied</span>`;
// };

// const avatarColors = ['#E05C4B', '#0D9488', '#1A73E8', '#C47D1A', '#8B4FA0'];

// // ── Gemini API call ─────────────────────────────────────────────────────────
// const callGemini = async (prompt) => {
//   const res = await fetch(
//     `https://generativelanguage.googleapis.com/v1beta/models/gemini-flash-latest:generateContent?key=${GEMINI_API_KEY}`,
//     {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ contents: [{ parts: [{ text: prompt }] }] }),
//     }
//   );
//   if (!res.ok) throw new Error(`Gemini API error: ${res.status}`);
//   const data = await res.json();
//   return data?.candidates?.[0]?.content?.parts?.[0]?.text || '';
// };

// // ── Play/Pause button ────────────────────────────────────────────────────────
// const PlayPauseButton = ({ text }) => {
//   const [playing, setPlaying]  = useState(false);
//   const [paused,  setPaused]   = useState(false);
//   const uttRef = useRef(null);

//   // Cleanup on unmount
//   useEffect(() => () => window.speechSynthesis.cancel(), []);

//   const handlePlay = () => {
//     if (paused && window.speechSynthesis.paused) {
//       // Resume
//       window.speechSynthesis.resume();
//       setPlaying(true);
//       setPaused(false);
//       return;
//     }
//     // Start fresh
//     window.speechSynthesis.cancel();
//     const utt = new SpeechSynthesisUtterance(text.replace(/<[^>]*>/g, ''));
//     utt.lang = 'en-IN';
//     utt.onend   = () => { setPlaying(false); setPaused(false); };
//     utt.onerror = () => { setPlaying(false); setPaused(false); };
//     uttRef.current = utt;
//     window.speechSynthesis.speak(utt);
//     setPlaying(true);
//     setPaused(false);
//   };

//   const handlePause = () => {
//     if (window.speechSynthesis.speaking && !window.speechSynthesis.paused) {
//       window.speechSynthesis.pause();
//       setPlaying(false);
//       setPaused(true);
//     }
//   };

//   const handleStop = () => {
//     window.speechSynthesis.cancel();
//     setPlaying(false);
//     setPaused(false);
//   };

//   return (
//     <div style={{ display: 'flex', gap: 6 }}>
//       {/* Play / Resume */}
//       <button
//         className="play-btn"
//         onClick={handlePlay}
//         disabled={playing && !paused}
//         title={paused ? 'Resume' : 'Play'}
//       >
//         <svg viewBox="0 0 24 24">
//           <path d="M8 5v14l11-7z"/>
//         </svg>
//         {paused ? 'Resume' : 'Play'}
//       </button>

//       {/* Pause — only show while playing */}
//       {playing && !paused && (
//         <button className="play-btn" onClick={handlePause} title="Pause">
//           <svg viewBox="0 0 24 24">
//             <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
//           </svg>
//           Pause
//         </button>
//       )}

//       {/* Stop — show when playing or paused */}
//       {(playing || paused) && (
//         <button className="play-btn" onClick={handleStop} title="Stop"
//           style={{ background: '#fce8e6', color: '#c62828' }}
//         >
//           <svg viewBox="0 0 24 24">
//             <path d="M6 6h12v12H6z"/>
//           </svg>
//           Stop
//         </button>
//       )}
//     </div>
//   );
// };

// // ── AI Insight Box ───────────────────────────────────────────────────────────
// const AIInsightBox = ({ prompt, cacheKey, title = 'AI Insight' }) => {
//   const [aiText,      setAiText]      = useState('');
//   const [aiLoading,   setAiLoading]   = useState(false);
//   const [aiError,     setAiError]     = useState('');
//   const INSIGHT_TTL = 24 * 60 * 60 * 1000;

//   // Load from cache on mount
//   useEffect(() => {
//     if (!cacheKey) return;
//     try {
//       const cached = localStorage.getItem(`ai_insight_${cacheKey}`);
//       if (cached) {
//         const { ts, text } = JSON.parse(cached);
//         if (Date.now() - ts < INSIGHT_TTL) {
//           setAiText(text);
//           return;
//         }
//       }
//     } catch {}
//     // Auto-generate if no cache
//     if (prompt) generateInsight();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [cacheKey]);

//   const generateInsight = async () => {
//     if (!prompt || !GEMINI_API_KEY) {
//       setAiError(!GEMINI_API_KEY
//         ? 'Gemini API key not set. Add REACT_APP_GEMINI_API_KEY to your .env file.'
//         : 'No prompt available.');
//       return;
//     }
//     setAiLoading(true);
//     setAiError('');
//     try {
//       const text = await callGemini(prompt);
//       setAiText(text);
//       if (cacheKey) {
//         localStorage.setItem(`ai_insight_${cacheKey}`, JSON.stringify({ ts: Date.now(), text }));
//       }
//     } catch (e) {
//       setAiError('Could not generate insight. Please check your API key and try again.');
//       console.error('Gemini error:', e);
//     } finally {
//       setAiLoading(false);
//     }
//   };

//   return (
//     <div className="insight-box" style={{ display: 'block' }}>
//       <div className="insight-header">
//         <div className="insight-title">
//           <svg viewBox="0 0 24 24">
//             <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z"/>
//           </svg>
//           {title}
//         </div>

//         <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//           {/* Refresh button */}
//           <button
//             className="play-btn"
//             onClick={generateInsight}
//             disabled={aiLoading}
//             title="Regenerate AI insight"
//             style={{ fontSize: 11 }}
//           >
//             {aiLoading ? (
//               <>
//                 <div style={{
//                   width: 10, height: 10,
//                   border: '2px solid currentColor',
//                   borderTopColor: 'transparent',
//                   borderRadius: '50%',
//                   animation: 'spin 0.8s linear infinite',
//                   display: 'inline-block',
//                 }} />
//                 Generating…
//               </>
//             ) : (
//               <>
//                 <svg viewBox="0 0 24 24" width="12" height="12">
//                   <path d="M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
//                 </svg>
//                 {aiText ? 'Refresh' : '✦ Generate'}
//               </>
//             )}
//           </button>

//           {/* Play/Pause — only when there's text */}
//           {aiText && !aiLoading && <PlayPauseButton text={aiText} />}
//         </div>
//       </div>

//       {/* Content area */}
//       {aiLoading && (
//         <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 0', fontSize: 13, color: '#6B4FA0' }}>
//           <div style={{
//             width: 16, height: 16,
//             border: '2px solid #6B4FA0',
//             borderTopColor: 'transparent',
//             borderRadius: '50%',
//             animation: 'spin 0.8s linear infinite',
//           }} />
//           Generating AI insight with Gemini Flash…
//         </div>
//       )}

//       {aiError && !aiLoading && (
//         <div style={{
//           fontSize: 12, color: '#c62828',
//           background: '#fce8e6', borderRadius: 8,
//           padding: '8px 12px', marginTop: 8,
//         }}>
//           {aiError}
//         </div>
//       )}

//       {aiText && !aiLoading && (
//         <div className="insight-text" style={{ marginTop: 8 }}>
//           {aiText}
//         </div>
//       )}

//       {!aiText && !aiLoading && !aiError && (
//         <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic', padding: '8px 0' }}>
//           Click "Generate" to get your AI-powered insight.
//         </div>
//       )}

//       {/* Spinner keyframes */}
//       <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//     </div>
//   );
// };

// // ── Main Component ────────────────────────────────────────────────────────────
// const OverallScores = ({ brandName, websiteUrl, location, competitors, onContinue }) => {
//   const [loading,     setLoading]     = useState(true);
//   const [clientScore, setClientScore] = useState(0);
//   const [clientLabel, setClientLabel] = useState({});
//   const [compScores,  setCompScores]  = useState([]);
//   const [scoreInputs, setScoreInputs] = useState({});

//   const brandDomain = cleanDomain(websiteUrl);

//   const isDataReady = () => {
//     if (!getAuthorityData(brandDomain)) return false;
//     if (!getPageSpeedData(brandDomain)) return false;
//     for (const comp of competitors) {
//       const d = cleanDomain(comp.website);
//       if (!d) continue;
//       if (!getAuthorityData(d) || !getPageSpeedData(d)) return false;
//     }
//     return true;
//   };

//   useEffect(() => {
//     let stopped = false;
//     debugCacheDump(brandDomain, location);

//     const tryCompute = () => {
//       if (stopped) return;
//       if (isDataReady()) {
//         stopped = true;
//         computeAllScores();
//         setLoading(false);
//       } else {
//         setTimeout(tryCompute, 500);
//       }
//     };

//     tryCompute();

//     const fallback = setTimeout(() => {
//       if (!stopped) {
//         stopped = true;
//         console.warn('⚠️ Score fallback fired');
//         computeAllScores();
//         setLoading(false);
//       }
//     }, 30_000);

//     return () => { stopped = true; clearTimeout(fallback); };
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [websiteUrl, location]);

//   const computeAllScores = () => {
//     const inputs     = buildScoreInputs(brandDomain, location);
//     const brandScore = computeOverallScore(inputs);
//     setClientScore(brandScore);
//     setClientLabel(getScoreLabel(brandScore));
//     setScoreInputs(inputs);

//     cacheWrite(CacheKeys.overallScore(brandDomain), {
//       overallScore: brandScore,
//       scoreInputs:  inputs,
//     });

//     const compResults = competitors.map((comp) => {
//       const d = cleanDomain(comp.website);
//       if (!d) return { ...comp, score: 0, label: getScoreLabel(0), oneliner: '', vsBadge: '' };
//       const ci = buildScoreInputs(d, location);
//       const sc = computeOverallScore(ci);
//       return {
//         ...comp,
//         score:    sc,
//         label:    getScoreLabel(sc),
//         oneliner: getOneliner(comp.name || d, sc),
//         vsBadge:  getVsBadge(brandScore, sc),
//       };
//     });
//     setCompScores(compResults);
//   };

//   // ── Build Gemini prompt for overall score ─────────────────────────────────
//   const buildPrompt = (score, label, inputs) => `You are a straight-talking digital marketing consultant writing for a business owner who is NOT a marketing expert.
// No jargon. No bullet points. Max 3 sentences. Be honest.
// Brand: ${brandName}
// Overall Score: ${score}/100
// Rating: ${label}  (Excellent / Strong / Developing / Needs Work)
// GMB Rating: ${inputs.gmbRating || 0} stars
// Total Reviews: ${inputs.reviewCount || 0}
// Keywords entered: several
// Website present: ${websiteUrl ? 'yes' : 'no'}
// Tell this business owner honestly what their overall brand score means — are they visible, trusted and competitive, or are they invisible to potential customers? What does this score cost them in real terms?`;

//   return (
//     <div className="card" id="card-4" style={{ padding: 10, overflow: 'hidden', borderRadius: '20px' }}>
//       <div className="eyebrow">Brand Audit</div>
//       <h2 className="ctitle">Overall Brand Scores</h2>
//       <p className="cdesc">Your brand score vs competitors — calculated from GMB data, reviews, online presence and keyword strength.</p>

//       {loading && (
//         <div className="audit-spinner show">
//           <div className="spinner" />
//           <span>Calculating brand scores…</span>
//         </div>
//       )}

//       {!loading && (
//         <>
//           <div className="scores-wrap show">
//             {/* Client block */}
//             <div className="client-score-block">
//               <div className="client-score-top">
//                 <div className="client-score-left">
//                   <div className="client-score-label">Your Brand</div>
//                   <div className="client-biz-name">{brandName}</div>
//                   <div className="client-oneliner">{getOneliner(brandName, clientScore)}</div>
//                 </div>
//                 <div className="client-score-right">
//                   <div className="big-score" style={{ color: clientLabel.color }}>{clientScore}</div>
//                   <div className="big-score-label" style={{ color: clientLabel.color }}>{clientLabel.label}</div>
//                 </div>
//               </div>
//               <div className="score-bar-wrap">
//                 <div className="score-bar-track">
//                   <div className="score-bar-fill brand" style={{ width: `${clientScore}%` }} />
//                 </div>
//               </div>
//             </div>

//             {/* Competitors */}
//             <div className="comp-scores-label">Competitors</div>
//             <div className="comp-score-rows">
//               {compScores.map((comp, idx) => {
//                 const color    = avatarColors[idx % avatarColors.length];
//                 const ini      = (comp.name || comp.website || '').split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase();
//                 const shortUrl = (comp.website || '').replace(/^https?:\/\//, '').replace(/\/$/, '');
//                 return (
//                   <div key={comp.id || idx} className="comp-score-row">
//                     <div className="csr-top">
//                       <div className="csr-left">
//                         <div className="csr-avatar" style={{ background: color }}>{ini}</div>
//                         <div>
//                           <div style={{ display:'flex', alignItems:'center', flexWrap:'wrap', gap:4 }}>
//                             <span className="csr-name">{comp.name || shortUrl}</span>
//                             <span className={`csr-label ${comp.label.cls}`}>{comp.label.label}</span>
//                             <span dangerouslySetInnerHTML={{ __html: comp.vsBadge }} />
//                           </div>
//                           {shortUrl && <div style={{ fontSize:11, color:'#1A73E8', marginTop:2 }}>{shortUrl}</div>}
//                         </div>
//                       </div>
//                       <div className="csr-right">
//                         <span className="csr-score" style={{ color: comp.label.color }}>{comp.score}</span>
//                         <span className="csr-score-sub">/100</span>
//                       </div>
//                     </div>
//                     <div className="csr-oneliner">{comp.oneliner}</div>
//                     <div className="score-bar-track">
//                       <div className={`score-bar-fill c${(idx % 5) + 1}`} style={{ width: `${comp.score}%` }} />
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>

//           {/* ── AI Insight Box ── */}
//           <AIInsightBox
//             title="AI Brand Score Insight"
//             cacheKey={`overall_score_${brandDomain}`}
//             prompt={buildPrompt(clientScore, clientLabel.label, scoreInputs)}
//           />
//         </>
//       )}

//       <button className="btn" onClick={onContinue} style={{ marginTop: 20 }}>
//         View Detailed Breakdown
//         <svg viewBox="0 0 24 24" fill="white">
//           <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/>
//         </svg>
//       </button>
//     </div>
//   );
// };

// export default OverallScores;

// src/components/BrandAudit/OverallScores.jsx
// ─────────────────────────────────────────────────────────────────────────────
// CHANGES FROM PREVIOUS VERSION:
//   1. compScores now carries rating + reviews from GMB cache (or comp object)
//      so the competitor prompt has real data instead of zeros.
//   2. Each competitor row gets its own AIInsightBox using the exact
//      per-competitor prompt format you specified.
//   3. Static oneliner below progress bar is kept as a fallback subtitle
//      while the AI insight generates — it no longer pretends to be the insight.
//   4. buildCompPrompt() — new function, one per competitor.
//   5. GEMINI_API_KEY reads from env var (REACT_APP_GEMINI_API_KEY).
// ─────────────────────────────────────────────────────────────────────────────

import React, { useState, useEffect, useRef } from 'react';
import { computeOverallScore } from '../../utils/scoreUtils';
import { cacheRead, cacheWrite, CacheKeys } from '../../utils/cacheKeys';
import{AIInsightsPage} from '../../utils/AIInsightsPage'
import { normalizeBrandName } from '../../utils/normalizeBrandName';
import { GoogleGenerativeAI } from "@google/generative-ai";


// ── Read API key from env (set REACT_APP_GEMINI_API_KEY in your .env) ────────
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || '';
//const GEMINI_API_KEY = "AIzaSyBnqz5EMI3AdnuMe_7B6NIF5Gq2Gr2MbfE";
const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);

const cleanDomain = (url) =>
  (url || '').replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

const getAuthorityData  = (domain)           => cacheRead(CacheKeys.authority(domain));
const getPageSpeedData  = (domain)           => cacheRead(CacheKeys.pageSpeed(domain));
const getGmbData        = (domain, location) => cacheRead(CacheKeys.gmb(domain, location));
const getTechnicalData  = (domain)           => cacheRead(CacheKeys.technical(domain));

const debugCacheDump = (domain, location) => {
  console.group(`📦 Cache dump for: ${domain}`);
  console.log('authority →', getAuthorityData(domain));
  console.log('pageSpeed →', getPageSpeedData(domain));
  console.log('gmb       →', getGmbData(domain, location));
  console.log('technical →', getTechnicalData(domain));
  const matching = Object.keys(localStorage).filter(k => k.includes(domain));
  console.log('All matching localStorage keys:', matching);
  console.groupEnd();
};

// const buildScoreInputs = (domain, location, gmbOverride = null) => {
//   const authority = getAuthorityData(domain)   || {};
//   const pageSpeed = getPageSpeedData(domain)   || {};
//   const gmb       = gmbOverride || getGmbData(domain, location) || {};
//   const tech      = getTechnicalData(domain)   || {};

//   const normPS = (val) => {
//     if (val == null) return 0;
//     return val <= 1 ? Math.round(val * 100) : val;
//   };

//   return {
//     domainAuthority:    authority.domain_authority   ?? 0,
//     spamScore:          authority.spam_score         ?? null,
//     domainAgeYears:     authority.domain_age_years   ?? 0,
//     referringDomains:   authority.referring_domains  ?? 0,
//     pageSpeedMobile:    normPS(pageSpeed?.mobile?.performance_score),
//     pageSpeedDesktop:   normPS(pageSpeed?.desktop?.performance_score),
//     isResponsive:       pageSpeed?.mobile?.viewport_meta_tag_present ?? null,
//     gmbRating:          gmb?.reviews?.rating   ?? 0,
//     reviewCount:        gmb?.reviews?.count    ?? 0,
//     daysSinceLastReview: gmb?.daysSinceLastReview ?? null,
//     servicesCount:      gmb?.services_listed?.status === 'pass'
//                           ? (gmb?.services_listed?.value || 1)
//                           : (gmb?.services_listed?.value || 0),
//     hasSitemap:     tech?.sitemap?.status    === 'Present' ? true  : tech?.sitemap?.status    === 'Missing'  ? false : null,
//     hasRobots:      tech?.robots_txt?.status === 'Present' ? true  : tech?.robots_txt?.status === 'Missing'  ? false : null,
//     hasBrokenLinks: (tech?.broken_links ?? null) === null ? null : (tech.broken_links > 0),
//     hasSSL:         tech?.ssl_status?.status === 'Secure'  ? true  : tech?.ssl_status?.status === 'Insecure' ? false : null,
//   };
// };

const buildScoreInputs = (domain, location, gmbOverride = null) => {
  const authority = getAuthorityData(domain)   || {};
  const pageSpeed = getPageSpeedData(domain)   || {};
  const gmb       = gmbOverride || getGmbData(domain, location) || {};
  const tech      = getTechnicalData(domain)   || {};

  const normPS = (val) => {
    if (val == null) return 0;
    return val <= 1 ? Math.round(val * 100) : val;
  };

  // ✅ Robust extraction – try multiple possible paths for rating and reviews
  const gmbRating = 
    gmb?.reviews?.value?.rating ?? 
    gmb?.reviews?.rating ?? 
    gmb?.rating ?? 
    0;

  const reviewCount = 
    gmb?.reviews?.value?.count ?? 
    gmb?.reviews?.count ?? 
    gmb?.user_ratings_total ?? 
    0;

  return {
    domainAuthority:    authority.domain_authority   ?? 0,
    spamScore:          authority.spam_score         ?? null,
    domainAgeYears:     authority.domain_age_years   ?? 0,
    referringDomains:   authority.referring_domains  ?? 0,
    pageSpeedMobile:    normPS(pageSpeed?.mobile?.performance_score),
    pageSpeedDesktop:   normPS(pageSpeed?.desktop?.performance_score),
    isResponsive:       pageSpeed?.mobile?.viewport_meta_tag_present ?? null,
    gmbRating:          gmbRating,
    reviewCount:        reviewCount,
    daysSinceLastReview: gmb?.daysSinceLastReview ?? null,
    servicesCount:      gmb?.services_listed?.status === 'pass' ? (gmb?.services_listed?.value || 1) : (gmb?.services_listed?.value || 0),
    hasSitemap:         tech?.sitemap?.status    === 'Present' ? true  : tech?.sitemap?.status    === 'Missing'  ? false : null,
    hasRobots:          tech?.robots_txt?.status === 'Present' ? true  : tech?.robots_txt?.status === 'Missing'  ? false : null,
    hasBrokenLinks:     (tech?.broken_links ?? null) === null ? null : (tech.broken_links > 0),
    hasSSL:             tech?.ssl_status?.status === 'Secure'  ? true  : tech?.ssl_status?.status === 'Insecure' ? false : null,
  };
};

const getScoreLabel = (score) => {
  if (score >= 80) return { label: 'Excellent',  cls: 'lbl-excellent', color: '#0D9488' };
  if (score >= 65) return { label: 'Strong',     cls: 'lbl-strong',    color: '#1A73E8' };
  if (score >= 45) return { label: 'Developing', cls: 'lbl-developing',color: '#C47D1A' };
  return               { label: 'Needs Work',   cls: 'lbl-weak',      color: '#C0392B' };
};

const getOneliner = (name, score) => {
  if (score >= 80) return `${name} has a strong, well-established presence.`;
  if (score >= 65) return `${name} is performing well — a few improvements could make it exceptional.`;
  if (score >= 45) return `${name} is developing but faces gaps competitors may exploit.`;
  return `${name} has significant opportunities to improve visibility.`;
};

const getVsBadge = (clientScore, compScore) => {
  const diff = clientScore - compScore;
  if (diff > 3)  return `<span class="vs-badge vs-ahead">▲ ${diff} pts ahead</span>`;
  if (diff < -3) return `<span class="vs-badge vs-behind">▼ ${Math.abs(diff)} pts behind</span>`;
  return `<span class="vs-badge vs-tied">≈ Tied</span>`;
};

const avatarColors = ['#E05C4B', '#0D9488', '#1A73E8', '#C47D1A', '#8B4FA0'];

// ─────────────────────────────────────────────────────────────────────────────
// GEMINI API helper
// ─────────────────────────────────────────────────────────────────────────────

const sleep = (ms) => new Promise(res => setTimeout(res, ms));

const callGemini = async (prompt, retries = 3, delay = 2000) => {
  if (!GEMINI_API_KEY) {
    throw new Error('REACT_APP_GEMINI_API_KEY not set in .env');
  }

  try {
    const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });

    const result = await model.generateContent(prompt);
    const response = await result.response;

    return response.text();

  } catch (error) {
    const status = error?.status || error?.response?.status;

    console.warn("Gemini error:", status, error?.message);

    // ✅ Handle rate limit (429)
    if (status === 429 && retries > 0) {
      console.warn(`⏳ Rate limited. Retrying in ${delay}ms...`);

      await sleep(delay);

      // exponential backoff
      return callGemini(prompt, retries - 1, delay * 2);
    }

    // ❗ quota exhausted (daily or hard limit)
    if (status === 429 && retries === 0) {
      throw new Error("Quota exhausted. Please try again later.");
    }

    throw new Error("Gemini API request failed");
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// Global singleton — prevents 9 cards fighting over speechSynthesis
// ─────────────────────────────────────────────────────────────────────────────
const activeSpeech = { id: null };

// ─────────────────────────────────────────────────────────────────────────────
// Play / Pause / Stop — works reliably across all 9 cards
// ─────────────────────────────────────────────────────────────────────────────
const PlayPauseButton = ({ text, id }) => {
  const instanceId  = useRef(id || Math.random().toString(36).slice(2));
  const [status, setStatus] = useState('idle'); // 'idle' | 'playing' | 'paused'
  const isPausedRef = useRef(false);  // track pause state in ref, NOT synth.paused

  useEffect(() => {
    return () => {
      // Only cancel if THIS instance is the one speaking
      if (activeSpeech.id === instanceId.current) {
        window.speechSynthesis.cancel();
        activeSpeech.id = null;
      }
    };
  }, []);

  const stop = () => {
    window.speechSynthesis.cancel();
    activeSpeech.id   = null;
    isPausedRef.current = false;
    setStatus('idle');
  };

  const handleClick = () => {
    const synth = window.speechSynthesis;

    // ── Currently playing → pause ──────────────────────────────────
    if (status === 'playing') {
      synth.pause();
      isPausedRef.current = true;
      setStatus('paused');
      return;
    }

    // ── Paused → resume ────────────────────────────────────────────
    // IMPORTANT: don't use synth.paused — use our own ref
    if (status === 'paused' && isPausedRef.current) {
      synth.resume();
      isPausedRef.current = false;
      setStatus('playing');
      return;
    }

    // ── Idle → start fresh ─────────────────────────────────────────
    // Cancel whatever else is playing (other cards)
    synth.cancel();
    isPausedRef.current = false;
    activeSpeech.id = instanceId.current;

    // Small delay after cancel — Chrome needs ~50ms before speak() works
    setTimeout(() => {
      const utt  = new SpeechSynthesisUtterance(text.replace(/<[^>]*>/g, ''));
      utt.lang   = 'en-IN';
      utt.rate   = 0.95;

      utt.onstart  = () => setStatus('playing');
      utt.onpause  = () => { isPausedRef.current = true;  setStatus('paused');  };
      utt.onresume = () => { isPausedRef.current = false; setStatus('playing'); };
      utt.onend    = () => {
        activeSpeech.id     = null;
        isPausedRef.current = false;
        setStatus('idle');
      };
      utt.onerror  = () => {
        activeSpeech.id     = null;
        isPausedRef.current = false;
        setStatus('idle');
      };

      synth.speak(utt);
    }, 50);
  };

  return (
    <div style={{ display: 'flex', gap: 6 }}>
      <button className="play-btn" onClick={handleClick}>
        <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
          {status === 'playing' ? (
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
          ) : (
            <path d="M8 5v14l11-7z" />
          )}
        </svg>
        {status === 'playing' ? 'Pause' : status === 'paused' ? 'Play' : 'Play'}
      </button>

      {/* {status !== 'idle' && (
        <button
          className="play-btn"
          onClick={stop}
          style={{ background: '#fce8e6', color: '#c62828' }}
        >
          <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
            <path d="M6 6h12v12H6z" />
          </svg>
          Stop
        </button>
      )} */}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// Generic AI Insight Box (reused for brand + each competitor)
// ─────────────────────────────────────────────────────────────────────────────
const INSIGHT_TTL = 24 * 60 * 60 * 1000;

const AIInsightBox = ({ prompt, cacheKey, title = 'AI Insight', autoGenerate = true }) => {
  const [aiText,    setAiText]    = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError,   setAiError]   = useState('');
  const generatedRef = useRef(false);

  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));


  useEffect(() => {
    if (!cacheKey) return;
    try {
      const cached = localStorage.getItem(`ai_insight_${cacheKey}`);
      if (cached) {
        const { ts, text } = JSON.parse(cached);
        if (Date.now() - ts < INSIGHT_TTL && text) {
          setAiText(text);
          return;
        }
      }
    } catch {}
    if (autoGenerate && !generatedRef.current) {
      generatedRef.current = true;
      generate();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cacheKey]);

  const generate = async () => {
    if (!prompt) return;
    if (!GEMINI_API_KEY) {
      setAiError('Add REACT_APP_GEMINI_API_KEY to your .env file.');
      return;
    }
    setAiLoading(true);
    setAiError('');
    try {
      await sleep(2000);
      const text = await callGemini(prompt);
      setAiText(text);
      if (cacheKey) {
        localStorage.setItem(`ai_insight_${cacheKey}`, JSON.stringify({ ts: Date.now(), text }));
      }
    } catch (e) {
      setAiError('Could not generate insight. Check your API key and try again.');
      console.error('Gemini error:', e);
    } finally {
      setAiLoading(false);
    }
  };

  return (
    <div className="insight-box">
      <div className="insight-header">
        <div className="client-oneliner">
          {/* <svg viewBox="0 0 24 24">
            <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z"/>
          </svg> */}
          {title}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* <button
            className="play-btn"
            onClick={generate}
            disabled={aiLoading}
            style={{ fontSize: 11 }}
            title="Regenerate"
          >
            {aiLoading ? (
              <><div className="spinner" style={{ width: 10, height: 10, borderWidth: 2 }} /> Generating…</>
            ) : (
              <><svg viewBox="0 0 24 24" width="12" height="12"><path d="M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>{aiText ? 'Refresh' : '✦ Generate'}</>
            )}
          </button> */}
          {aiText && !aiLoading && (
            <PlayPauseButton text={aiText} id={cacheKey} />
          )}
        </div>
      </div>

      {aiLoading && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 0', fontSize: 13, color: '#6B4FA0' }}>
          <div className="spinner" style={{ width: 16, height: 16 }} />
          Analyzing your overall score…
        </div>
      )}
      {aiError && !aiLoading && (
        <div style={{ fontSize: 12, color: '#c62828', background: '#fce8e6', borderRadius: 8, padding: '8px 12px', marginTop: 8 }}>
          {aiError}
        </div>
      )}
      {aiText && !aiLoading && (
        <div className="insight-text" style={{ marginTop: 8 }}>{aiText}</div>
      )}
      {!aiText && !aiLoading && !aiError && (
        <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic', padding: '8px 0' }}>
          Click "Generate" to get your AI-powered insight.
        </div>
      )}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// Prompt builders
// ─────────────────────────────────────────────────────────────────────────────

// ─── Replace buildBrandPrompt ────────────────────────────────────────
const buildBrandPrompt = ({
  brandName,
  websiteUrl,
  clientScore,
  clientLabel,      // string e.g. "Developing"
  scoreInputs,
  compScores = [],  // ← pass competitors
  location = '',
}) => {
  // Top competitor for comparison
  const topComp = compScores[0];
  const compLine = topComp
    ? `Top competitor: ${topComp.name || topComp.website} scores ${topComp.score}/100 ` +
      `(GMB: ${Number(topComp.rating || 0).toFixed(1)}★, ${topComp.reviews || 0} reviews)`
    : 'No competitor data available';

  // Which dimension is weakest
  const dims = {
    'Domain Authority': scoreInputs.domainAuthority   || 0,
    'Page Speed':       scoreInputs.pageSpeedMobile   || 0,
    'GMB Rating':       Math.round((scoreInputs.gmbRating || 0) / 5 * 100),
    'Review Count':     Math.min(Math.round((scoreInputs.reviewCount || 0) / 200 * 100), 100),
  };
  const weakest = Object.entries(dims).reduce((a, b) => a[1] < b[1] ? a : b);

  return `You are a straight-talking digital marketing consultant speaking directly to the owner of ${brandName}${location ? ` in ${location}` : ''}.

Be honest, warm, and direct. Use "your" and "you". No bullet points. No jargon. No words like: leverage, synergy, holistic, robust, actionable.
Write exactly 3 sentences total.

THEIR DATA:
- Overall Brand Score: ${clientScore}/100 (${clientLabel})
- Domain Authority: ${scoreInputs.domainAuthority || 0}/100
- Mobile Page Speed: ${scoreInputs.pageSpeedMobile || 0}/100
- Google Rating: ${scoreInputs.gmbRating || 0} stars from ${scoreInputs.reviewCount || 0} reviews
- Website: ${websiteUrl ? 'yes' : 'no'}
- Weakest area: ${weakest[0]} (${weakest[1]}/100)
- ${compLine}

Sentence 1: Tell them honestly where they stand right now — reference the actual score (${clientScore}/100) and what it means for how easily customers can find them.
Sentence 2: Compare them to ${topComp?.name || 'their main competitor'} — who is winning and by how much? Make the gap feel real.
Sentence 3: Name the single weakest area (${weakest[0]}) and tell them what fixing it in the next 30 days would change. End with one warm human sentence.`;
};

// ─────────────────────────────────────────────────────────────────────────────
// Main Component
// ─────────────────────────────────────────────────────────────────────────────
const OverallScores = ({ brandName, websiteUrl, location, competitors, onContinue }) => {
  const [loading,      setLoading]      = useState(true);
  const [clientScore,  setClientScore]  = useState(0);
  const [clientLabel,  setClientLabel]  = useState({});
  const [compScores,   setCompScores]   = useState([]);
  const [scoreInputs,  setScoreInputs]  = useState({});

  const brandDomain = cleanDomain(websiteUrl);

  const isDataReady = () => {
    if (!getAuthorityData(brandDomain)) return false;
    if (!getPageSpeedData(brandDomain)) return false;
    for (const comp of competitors) {
      const d = cleanDomain(comp.website);
      if (!d) continue;
      if (!getAuthorityData(d) || !getPageSpeedData(d)) return false;
    }
    return true;
  };

  useEffect(() => {
    let stopped = false;
    debugCacheDump(brandDomain, location);

    const tryCompute = () => {
      if (stopped) return;
      if (isDataReady()) {
        stopped = true;
        computeAllScores();
        setLoading(false);
      } else {
        setTimeout(tryCompute, 500);
      }
    };

    tryCompute();

    const fallback = setTimeout(() => {
      if (!stopped) {
        stopped = true;
        console.warn('⚠️ Score fallback fired — computing with available data');
        computeAllScores();
        setLoading(false);
      }
    }, 30_000);

    return () => { stopped = true; clearTimeout(fallback); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [websiteUrl, location]);

  const computeAllScores = () => {
    const inputs     = buildScoreInputs(brandDomain, location);
    const brandScore = computeOverallScore(inputs);

    setClientScore(brandScore);
    setClientLabel(getScoreLabel(brandScore));
    setScoreInputs(inputs);

    cacheWrite(CacheKeys.overallScore(brandDomain), {
      overallScore: brandScore,
      scoreInputs:  inputs,
    });

    const compResults = competitors.map((comp) => {
      const d = cleanDomain(comp.website);
      if (!d) {
        return {
          ...comp,
          score: 0, label: getScoreLabel(0),
          rating:  comp.rating  || 0,
          reviews: comp.reviews || 0,
          vsBadge: getVsBadge(brandScore, 0),
        };
      }

      const ci = buildScoreInputs(d, location);
      const sc = computeOverallScore(ci);

      const compGmb = getGmbData(d, location) || {};
      const rating  = compGmb?.reviews?.rating ?? comp.rating  ?? 0;
      const reviews = compGmb?.reviews?.count  ?? comp.reviews ?? 0;

      return {
        ...comp,
        score:   sc,
        label:   getScoreLabel(sc),
        rating,
        reviews,
        vsBadge: getVsBadge(brandScore, sc),
      };
    });

    setCompScores(compResults);
  };

  return (
    <div className="card" id="card-4" style={{ padding: 10, overflow: 'hidden', borderRadius: '20px' }}>
      <div className="eyebrow">Digital Performance Index</div>
      <h2 className="ctitle">Overall Brand Scores</h2>
      <p className="cdesc">Your brand’s performance in the competitive landscape.</p>

      {loading && (
        <div className="audit-spinner show">
          <div className="spinner" />
          <span>Calculating brand scores…</span>
        </div>
      )}

      {!loading && (
        <>
          <div className="scores-wrap show">
            {/* Brand block (without AI insight) */}
            <div className="client-score-block">
              <div className="client-score-top">
                <div className="client-score-left">
                  <div className="client-score-label">Your Brand</div>
                  <div className="client-biz-name" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{brandName}</div>
                  <div className="client-oneliner">{getOneliner(brandName, clientScore)}</div>
                </div>
                <div className="client-score-right">
                  <div className="big-score" style={{ color: clientLabel.color }}>{clientScore}</div>
                  <div className="big-score-label" style={{ color: clientLabel.color }}>{clientLabel.label}</div>
                </div>
              </div>
              <div className="score-bar-wrap">
                <div className="score-bar-track">
                  <div className="score-bar-fill brand" style={{ width: `${clientScore}%` }} />
                </div>
              </div>
            </div>

            {/* Competitors section */}
            <div className="comp-scores-label" style={{ marginTop: 24 }}>Competitors</div>
            <div className="comp-score-rows">
              {compScores.map((comp, idx) => {
                const color    = avatarColors[idx % avatarColors.length];
                const ini      = (comp.name || comp.website || '').split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
                const shortUrl = (comp.website || '').replace(/^https?:\/\//, '').replace(/\/$/, '');
                const compDomain = cleanDomain(comp.website || '');

                // const compPrompt = buildCompetitorPrompt({
                //   brandName,
                //   clientScore,
                //   clientRating:  scoreInputs.gmbRating  || 0,
                //   clientReviews: scoreInputs.reviewCount || 0,
                //   competitorName: normalizeBrandName(comp.name || shortUrl),
                //   compScore:     comp.score,
                //   compRating:    comp.rating  || 0,
                //   compReviews:   comp.reviews || 0,
                // });

                // const compCacheKey = `comp_insight_${brandDomain}_${compDomain || idx}`;

                return (
                  <div key={comp.id || idx} className="comp-score-row" style={{ marginBottom: 4 }}>
                    {/* Score header row */}
                    <div className="csr-top">
                      <div className="csr-left" style={{ alignItems: 'flex-start' }}>
                        <div className="csr-avatar" style={{ background: color }}>{ini}</div>
                        <div>
                          <div>
                          <span className="csr-name" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {comp.name || shortUrl}
                          </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4, marginTop: 2, marginLeft: 0, paddingLeft: -10 }}>
                        <span className={`csr-label ${comp.label.cls}`}>{comp.label.label}</span>
                        <span dangerouslySetInnerHTML={{ __html: comp.vsBadge }} />
                      </div>
                          {/* <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
                            <span className="csr-name" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{comp.name || shortUrl}</span>
                            <span className={`csr-label ${comp.label.cls}`}>{comp.label.label}</span>
                            <span dangerouslySetInnerHTML={{ __html: comp.vsBadge }} />
                          </div> */}
                          {shortUrl && <div style={{ fontSize: 11, color: '#1A73E8', marginTop: 2 }}>{shortUrl}</div>}
                          {(comp.rating > 0 || comp.reviews > 0) && (
                            <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                              {comp.rating > 0 && <span>★ {Number(comp.rating).toFixed(1)}</span>}
                              {comp.rating > 0 && comp.reviews > 0 && <span style={{ margin: '0 4px' }}>·</span>}
                              {comp.reviews > 0 && <span>{comp.reviews.toLocaleString()} reviews</span>}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="csr-right">
                        <span className="csr-score" style={{ color: comp.label.color }}>{comp.score}</span>
                        <span className="csr-score-sub">/100</span>
                      </div>
                    </div>

                    {/* ★ No static one‑liner – only AI insight */}
                    {/* <AIInsightBox
                      title={`vs ${comp.name || shortUrl}`}
                      cacheKey={compCacheKey}
                      prompt={compPrompt}
                      autoGenerate={!!GEMINI_API_KEY}
                    /> */}

                    {/* Progress bar */}
                    <div className="score-bar-track" style={{ marginTop: 8 }}>
                      <div className={`score-bar-fill c${(idx % 5) + 1}`} style={{ width: `${comp.score}%` }} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* ── Brand AI insight at the very bottom of the card ── */}
          
{/* ── Brand AI insight ── */}
      <AIInsightBox
        
        title="INSIGHT"
        cacheKey={`overall_score_${brandDomain}`}
        prompt={buildBrandPrompt({
          brandName,
          websiteUrl,
          clientScore,
          clientLabel: clientLabel.label,   // ✅ was: clientLabel (object) — bug fixed
          scoreInputs,
          compScores,                        // ✅ was: missing entirely
          location,                          // ✅ was: missing
        })}
        autoGenerate={!!GEMINI_API_KEY}
      />
        </>
      )}

      <button className="btn" onClick={onContinue} style={{ marginTop: 20 }}>
        View Detailed Breakdown
        <svg viewBox="0 0 24 24" fill="white">
          <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/>
        </svg>
      </button>
    </div>
  );
};

export default OverallScores;